import { useWorkorderItems } from '.';
import { Button, Divider, Switch, Tooltip } from 'antd';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ServiceListSystem from './ServiceList/ServiceSystem';
import ServiceListExecuted from './ServiceList/ServiceExecuted';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { ServiceListType } from './WorkOrderSteps';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { AuthorityWorkorder } from '@/types/Authority/Authority.Workorder';

interface Props {
  onCancel: VoidFunction;
  serviceListType: ServiceListType;
  setServiceListType: (value: ServiceListType) => void;
}

function SelectServiceList({
  onCancel,
  serviceListType,
  setServiceListType,
}: Props) {
  const { onNextStep, onPrevStep } = useWorkorderItems();

  const { items } = useWorkorderItems();

  const {
    workorder: { data: workorder },
  } = useWorkorderDetailContext();

  return (
    <>
      <div>
        Histórico de serviços por veículo:{' '}
        <Tooltip
          title={!workorder?.vehicle ? 'Orçamento sem veículo' : undefined}
        >
          <Switch
            checkedChildren="Sim"
            unCheckedChildren="Não"
            disabled={!workorder?.vehicle}
            checked={serviceListType === ServiceListType.Executed}
            onChange={(checked) =>
              setServiceListType(
                checked ? ServiceListType.Executed : ServiceListType.System,
              )
            }
          />
        </Tooltip>
      </div>

      <Divider />

      {serviceListType === ServiceListType.Executed && <ServiceListExecuted />}

      {serviceListType === ServiceListType.System && <ServiceListSystem />}

      <SpaceForButton justifyContent="end" style={{ marginTop: 10 }}>
        <Button block onClick={onCancel}>
          Cancelar
        </Button>

        <Button block onClick={() => onPrevStep()}>
          Voltar
        </Button>

        <Button
          block
          type="primary"
          onClick={onNextStep}
          disabled={
            !hasPermissions([
              AuthorityWorkorder.MOVIMENTATION_WORKORDER_ADD_PART_SERVICE_TYPED,
            ]) && items?.length < 1
          }
        >
          Próximo
        </Button>
      </SpaceForButton>
    </>
  );
}

export default SelectServiceList;
